<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="tabs">
      <div @click="typeFun(0)" style="width: 200px" class="left" :class="{ active: carType === 0 }">常规车</div>
      <div @click="typeFun(1)" style="width: 200px" class="center" :class="{ active: carType === 1 }">资源车</div>
      <div @click="typeFun(2)" style="width: 350px" class="center" :class="{ active: carType === 2 }">常规车补结算</div>
      <div @click="typeFun(7)" style="width: 350px" class="right" :class="{ active: carType === 7 }">资源车补结算</div>
    </div>
    <div class="nav" v-if="carType === 0 || carType === 1">
      <div class="navContainer" style="width: 230px">
        <p>委托商：</p>
        <el-input v-model="entrustIpt" size="mini" style="width: 150px" placeholder="请输入委托商" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>批次号：</p>
        <el-input v-model="batchIpt" size="mini" style="width: 150px" placeholder="请输入批次号" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运单编号：</p>
        <el-input v-model="waybillIpt" size="mini" style="width: 150px" placeholder="请输入运单编号" />
      </div>
      <div class="navContainer" style="width: 230px" v-if="carType === 0">
        <p>车架号：</p>
        <el-input v-model="chassisIpt" size="mini" style="width: 150px" placeholder="请输入车架号" @paste.native.capture.prevent="
            value => {return searchCopyFormat(value, 'chassisIpt')}" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>品牌：</p>
        <el-input v-model="brandIpt" size="mini" style="width: 150px" placeholder="请输入品牌" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>台账月：</p>
        <el-input v-model="monthIpt" size="mini" style="width: 150px" placeholder="请输入台账月" />
      </div>
      <div class="navContainer" style="width: 300px">
        <p style="width: 130px">补结算对账编号：</p>
        <el-input v-model="actNoAdd" size="mini" style="width: 170px" placeholder="请输入补结算对账编号" />
      </div>
      <div class="navContainer" style="width: 300px">
        <p style="width: 130px">补结算对账标题：</p>
        <el-input v-model="titleAdd" size="mini" style="width: 170px" placeholder="请输入补结算对账标题" />
      </div>
      <div class="navContainer" style="width: 400px">
        <p>计划日期：</p>
        <!-- :default-time="['00:00:00', '23:59:59']" -->
        <el-date-picker
          v-model="timeIpt"
          type="daterange"
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini">
        </el-date-picker>
        <el-date-picker v-if="false"
          v-model="timeIpt[0]" size="mini" style="width: 150px"
          value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="date" placeholder="开始日期" />
        <span v-if="false" style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-if="false"
          v-model="timeIpt[1]" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss"
          @change="dateChange1" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer" style="width: 400px">
        <p>交车日期：</p>
        <el-date-picker
          v-model="dealersIpt"
          type="daterange"
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini">
        </el-date-picker>
        <el-date-picker v-if="false"
          v-model="dealersIpt[0]" size="mini" style="width: 150px" value-format="yyyy-MM-dd"
          @change="dateChange2" type="date" placeholder="开始日期" />
        <span v-if="false" style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-if="false"
          v-model="dealersIpt[1]" size="mini" style="width: 150px"
          value-format="yyyy-MM-dd" @change="dateChange2" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer" style="width: 230px" v-if="carType === 0">
        <p>运输方式：</p>
        <el-select
          v-model="termsIpt"
          filterable
          size="mini"
          style="width: 150px"
          placeholder="请选择">
          <el-option
            v-for="item in termsOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 270px">
        <p style="width: 120px !important">是否生成对账单：</p>
        <el-select
          v-model="stateIpt"
          filterable
          size="mini"
          style="width: 150px"
          placeholder="请选择">
          <el-option
            v-for="item in stateOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 270px">
        <p style="width: 120px !important">是否生成补结算：</p>
        <el-select v-model="isAdd" filterable size="mini" style="width: 150px" placeholder="请选择">
          <el-option
            v-for="item in addOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">生成对账单</el-button>
        <el-button size="small" type="primary" @click="addResetBtn">刷新结算</el-button>
        <!--        <el-button size='small' type='primary' @click='ledgerRevise'>修改台账月</el-button>-->
        <el-button size="small" type="primary" @click="priceRefresh(carType)">价格刷新</el-button>
        <oil-import
          class="ml10"
          :uploadUrl="'/customer/account/importConsignorOilPriceLink'"
          :uploadText="'油价联动导入'"
          :is-button="true"
          :button-size="'small'"
          @triggerLoading="importLoading = !importLoading" />
        <el-button v-if="carType === 0" size="small" type="primary" @click="regularToResource">常规车到资源车</el-button>
      </div>
    </div>
    <el-row v-if="carType === 1">
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="download" class="pointer">模板下载</span>
        <span style="cursor: pointer; display: inline-block">
          <import-statement
            @getList="searchBtn"
            @changeImportLoading="changeImportLoading"
            :type="10" />
        </span>
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <check-table
        v-if="carType === 0"
        :columnOne="columnOne"
        :dataOne="dataOne"
        :columnTwo="columnTwo"
        :field="tableField"
        :childFiled="childName"
        @checkChange="checkChang"
        @exportData="exportData"
        ref="checkTable"
        @getList="searchBtn">
        <!-- v-if="!loadTable" -->
        <!-- ref="del"  调用子组件方法 -->
      </check-table>
      <div class="tableContainer" v-if="carType === 1">
        <el-table
          v-loading="tableLoading"
          :data="dataOne"
          style="width: 100%"
          border
          ref="multipleTable"
          @select="handleCurrentChange"
          @select-all="handleCurrentChange"
          :reserve-selection="true"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#3b3b3b', 'font-size': '13px', height: '35px' }"
          :row-key=" row => { return row.id;} "
          :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="50px" :selectable="row => {return row.isReconciliation !== 1}" />
          <el-table-column prop="consignorName" label="委托商" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="batchNumber" label="批次号" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="waybillNo" label="运单编号" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="startPortName" label="起始港" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="deliveryPortName" label="目的港"  width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="standingBookMonth" label="台账月" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="brandName"  width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="modelName" label="型号" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="personnelNames" label="船名" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="plannedDate" label="计划日期" width="160px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.plannedDate | tableValueFormat('plannedDate') }}
            </template>
          </el-table-column>
          <el-table-column prop="deliveryDate" label="交车日期" width="160px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.deliveryDate | tableValueFormat('deliveryDate') }}
            </template>
          </el-table-column>
          <el-table-column prop="carNumber" label="数量" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="taxRate" label="税率(%)" width="160px" align="center" show-overflow-tooltip />
          <el-table-column label="单价" width="160px" align="center" :formatter="priceFormat" show-overflow-tooltip />
          <el-table-column prop="taxContractPrice" label="含税合同价" width="160px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.taxContractPrice ? scope.row.taxContractPrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="taxPreparePrice" label="含税预结算价" width="160px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.taxPreparePrice ? scope.row.taxPreparePrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='receiptNumber' label='交单编号' align='center' width='160' show-overflow-tooltip/>
          <el-table-column prop="isReconciliation" label="生成对账单" width="160px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.isReconciliation | tableValueFormat('isReconciliation') }}
            </template>
          </el-table-column>
          <el-table-column prop="actNo" label="对账单编号" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="title" label="对账单标题" width="180px" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="isAdd" label="是否生成补结算" width="160px" align="center" show-overflow-tooltip :formatter="isAddFormat" />
          <el-table-column prop="actNoAdd" label="补结算对账编号" width="160px" align="center" show-overflow-tooltip />
          <el-table-column prop="titleAdd" label="补结算对账标题" width="160px" align="center" show-overflow-tooltip />
        </el-table>
      </div>
      <div class="paginationContainer" v-if="carType === 1 || carType === 0">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="carType === 0 ? [50, 100, 500, 1000,5000] : [50, 100, 500, 1000,2000]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <!-- 对账单 -->
    <el-dialog
      :title="importShow ? '导入生成对账单' : '生成对账单'"
      :visible.sync="dialogVisible"
      :width="dialogWith"
      center
      @close="dialogClose">
      <!--  check-table-data 传入需要展示的数据     -->
      <!--  importShow  判断是否是导入生成对账单or 生成对账单   -->
      <!--  selectionTable 运单费用操作删除触发  传出删除后数据据 多选表格联动 重新勾选   -->
      <consignorAccount
        v-if="carType === 0"
        @closeDialogAndSearch="closeDialogAndSearch"
        :importShow="importShow"
        :settlement="settlement"
        ref="accountState">
        <template slot="label">基础信息</template>
        <template slot="label2">运单费用</template>
        <template slot="label3">其他费用</template>
      </consignorAccount>
      <consignor-resources-car-account
        v-else
        @closeDialogAndSearch="closeDialogAndSearch"
        :importShow="importShow"
        :settlement="settlement"
        ref="accountState">
        <template slot="label">基础信息</template>
        <template slot="label2">运单费用</template>
        <template slot="label3">其他费用</template>
      </consignor-resources-car-account>
    </el-dialog>

    <!-- 修改台账月 -->
    <el-dialog
      title="修改台账月"
      :visible.sync="ledgerVisible"
      width="750px"
      center
      @close="ledgerClose">
      <div class="ledger">
        <div class="leader-input">
          <span>请输入台账月：</span>
          <el-input size="small" type="text" v-model="ledger" style="display: inline-block" />
          <div style="display: inline-block; width: calc(100% - 300px); text-align: right">
            <el-button size="small" class="searchBtn" @click="ledgerChange">确 定</el-button>
            <el-button size="small" class="resetBtn" @click="ledgerClose">取 消</el-button>
          </div>
        </div>
        <el-table
          v-loading="ledgerLoad"
          :data="ledgerData"
          style="width: 100%"
          border
          :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B' }">
          <el-table-column prop="batchNumber" label="批次号" min-width="150" show-overflow-tooltip align="center" />
          <el-table-column prop="waybillNo" label="运单号" min-width="150"  show-overflow-tooltip align="center" />
          <el-table-column v-if="!carType" prop="frameNumber" label="车架号" min-width="150" show-overflow-tooltip align="center" />
          <el-table-column prop="brandName" label="品牌" min-width="100" show-overflow-tooltip align="center" />
          <el-table-column prop="modelName" label="型号" min-width="100" show-overflow-tooltip align="center" />
          <el-table-column label="起始地" min-width="150" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              {{ carType === 1 ? scope.row.startPortName : scope.row.departurePlace }}
            </template>
          </el-table-column>
          <el-table-column prop="arrivePlace"  label="交车地" min-width="150" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              {{ carType === 1 ? scope.row.deliveryPortName : scope.row.arrivePlace }}
            </template>
          </el-table-column>
          <el-table-column prop="standingBookMonth" label="台账月" min-width="120" show-overflow-tooltip align="center" />
          <!--          <el-table-column prop="taxContractPrice" label="含税合同价" min-width="100" align="center"/>-->
          <!--          <el-table-column prop="contractPrice" label="不含税合同价" min-width="110" align="center"/>-->
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <i class="el-icon-error" style="font-size: 20px" @click="delLedger(scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 常规车补结算 -->
    <conventional-car v-if="carType === 2" />
    <!-- 资源车补结算 -->
    <resource-vehicle v-if="carType === 7" />
  </div>
</template>

<script>
  import checkTable from '@/components/checkTable.vue';
  import oilImport from './components/oilImport.vue';
  import consignorAccount from '@/views/settle/entrust/components/consignorAccount.vue';
  import consignorResourcesCarAccount from '@/views/settle/entrust/components/consignorResourcesCarAccount';
  import {
    changeResource,
    consignmentList,
    consignmentRefreshAccount,
    consignOrLineConsignor,
    consignOrLinePriceRefresh,
    refreshAccount,
    shippingFee,
    updateBatchStandingBookMonth,
    updateStandingBookMonth,
  } from '@/service/basicfile';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import ImportStatement from '@/views/settle/entrust/components/import-statement';
  import ConventionalCar from '@/views/settle/entrust/components/conventionalCar.vue';
  import ResourceVehicle from '@/views/settle/entrust/components/resourceVehicle.vue';
  // import { format } from 'echarts/lib/export';

  export default {
    components: {
      ResourceVehicle,
      ConventionalCar,
      oilImport,
      checkTable,
      consignorAccount,
      consignorResourcesCarAccount,
      ImportStatement,
    },
    data() {
      return {
        carType: 0, // 0：常规车 1：资源车 暂时
        activeName: 'first', // 生成对账单弹窗默认显示
        batchIpt: '', // 批次号
        waybillIpt: '', // 运单编号
        chassisIpt: '', // 底盘号
        entrustIpt: '', // 委托商
        brandIpt: '', // 品牌名称
        monthIpt: '', // 台账月
        actNoAdd: '', //补结算对账编号
        titleAdd: '', //补结算对账标题
        dealersIpt: ['', ''], // 交车日期
        timeIpt: ['', ''], // 计划日期
        stateIpt: '', // 是否生成对账单
        isAdd: '', //是否生成补结算
        termsIpt: '', // 运输方式
        // 是否生成对账单下拉数据
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '否',
          },
          {
            value: 1,
            label: '是',
          },
          {
            value: 2,
            label: '部分生成',
          },
        ],
        // 是否生成补结算下拉数据
        addOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '否',
          },
          {
            value: 1,
            label: '是',
          },
        ],
        // 运输方式
        termsOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '公路',
          },
          {
            value: 2,
            label: '水路',
          },
          {
            value: 3,
            label: '水陆联运',
          },
        ],
        page: 1,
        size: 50,
        total: 0,
        dialogVisible: false, // 生成对账单弹窗是否显示
        dialogWith: '950px', // 生成对账单弹窗宽度
        importShow: true, // 判断是否是导入生成对账单（ture） or生成对账单
        // 生成对账单弹窗提示信息
        rules: {
          type: [
            {
              required: true,
              message: '请选择地址类型',
              trigger: 'change',
            },
          ],
          name: [
            {
              required: true,
              message: '请输入地址名称',
              trigger: 'blur',
            },
          ],
          address: [
            {
              required: true,
              message: '请输入详细地址',
              trigger: 'blur',
            },
          ],
          area: [
            {
              required: true,
              message: '请现在所在区域',
              trigger: 'change',
            },
          ],
        },
        oldList: {},
        expands: [],
        minTable: [], // 二级表格选中数据
        // table的各种数据
        // 一级表头
        columnOne: [
          {
            id: 'th1',
            width: '150',
            title: '委托商',
            name: 'consignorName',
          },
          {
            id: 'th2',
            width: '150',
            title: '批次号',
            name: 'batchNumber',
          },
          {
            id: 'th3',
            width: '150',
            title: '运单编号',
            name: 'waybillNo',
          },
          {
            id: 'th4',
            width: '160',
            title: '车架号',
            name: 'frameNumber',
          },
          {
            id: 'th5',
            width: '100',
            title: '品牌',
            name: 'brandName',
          },
          {
            id: 'th6',
            width: '100',
            title: '型号',
            name: 'modelName',
          },
          {
            id: 'th7',
            width: '150',
            title: '起始地',
            name: 'departurePlace',
          },
          {
            id: 'th8',
            width: '150',
            title: '交车地',
            name: 'arrivePlace',
          },
          {
            id: 'th9',
            width: '120',
            title: '台账月',
            name: 'standingBookMonth',
          },
          {
            id: 'th10',
            width: '110',
            title: '计划日期',
            name: 'plannedDate',
          },
          // {id:'th9',width:'110', title:'发运日期', name: 'dispatchDate'},
          {
            id: 'th11',
            width: '110',
            title: '交车日期',
            name: 'deliveryDate',
          },
          {
            id: 'th12',
            width: '70',
            title: '运输方式',
            name: 'transportationTerms',
          },
          {
            id: 'th13',
            width: '60',
            title: '税率(%)',
            name: 'taxRate',
          },
          {
            id: 'th14',
            width: '80',
            title: '含税合同价',
            name: 'taxContractPrice',
          },
          {
            id: 'th15',
            width: '90',
            title: '不含税合同价',
            name: 'contractPrice',
          },
          // {id:'th15',width:'90', title:'预结算方式', name: 'prepareType'},
          {
            id: 'th16',
            width: '100',
            title: '含税预结算价',
            name: 'taxPreparePrice',
          },
          {
            id: 'th17',
            width: '110',
            title: '不含税预结算价',
            name: 'preparePrice',
          },
          {
            id: 'th18',
            width: '80',
            title: '油价联动金额',
            name: 'oilPrice',
          },
          {
            id: 'th20',
            width: '130',
            title: '是否生成补结算',
            name: 'isAdd',
          },
          {
            id: 'th21',
            width: '80',
            title: '生成对账单',
            name: 'isReconciliation',
          },
          {
            id: 'th22',
            width: '150',
            title: '对账单编号',
            name: 'actNo',
          },
          {
            id: 'th23',
            width: '150',
            title: '对账单标题',
            name: 'title',
          },
          {
            id: 'th24',
            width: '150',
            title: '补结算对账编号',
            name: 'actNoAdd',
          },
          {
            id: 'th25',
            width: '150',
            title: '补结算对账标题',
            name: 'titleAdd',
          },
          {
            id: 'th19',
            width: '150',
            title: '交单编号',
            name: 'receiptNumber',
          },
          {
            id: 'th26',
            width: '130',
            title: '交单备注',
            name: 'surrenderRemarks',
          },
        ],
        // 列表数据
        dataOne: [],
        // 二级表头
        columnTwo: [
          // {id:'td-th1', width:'120', title:'运单编号', name: 'waybillNo'},
          {
            id: 'td-th1',
            width: '150',
            title: '运输方式',
            name: 'transportationTerms',
          },
          {
            id: 'td-th2',
            width: '150',
            title: '起始地',
            name: 'departurePlace',
          },
          {
            id: 'td-th3',
            width: '150',
            title: '交车地',
            name: 'arrivePlace',
          },
          {
            id: 'td-th4',
            width: '150',
            title: '台账月',
            name: 'standingBookMonth',
          },
          {
            id: 'td-th5',
            width: '150',
            title: '含税合同价',
            name: 'taxContractPrice',
          },
          {
            id: 'td-th6',
            width: '150',
            title: '不含税合同价',
            name: 'contractPrice',
          },
          // {id:'td-th5', width:'120', title:'预结算方式', name: 'prepareType'},
          {
            id: 'td-th7',
            width: '150',
            title: '含税预结算价',
            name: 'taxPreparePrice',
          },
          {
            id: 'td-th8',
            width: '150',
            title: '不含税预结算价',
            name: 'preparePrice',
          },
          {
            id: 'td-th9',
            width: '80',
            title: '油价联动金额',
            name: 'oilPrice',
          },
          {
            id: 'th18',
            width: '120',
            title: '对账单编号',
            name: 'title',
          },
          {
            id: 'th19',
            width: '150',
            title: '交单编号',
            name: 'receiptNumber',
          },
          // {
          //   id: 'td-th10',
          //   width: '150',
          //   title: '生成对账单',
          //   name: 'isReconciliation',
          // },
        ],
        childName: 'childs', // 子表格数组名
        // 其他字段
        tableField: {
          terms1: 'transportationTerms', // 一级菜单的运输方式字段
          terms2: 'transportationTerms', // 二级菜单的运输方式字段
          termsChick: true, // 运输方式全选框是否显示
          importExport: true, // 导入导出是否显示
          select: true, // 是否显示复选框
        },
        checkData: [], // 选中数据
        settlement: '', // 生成对账单时的结算方式
        // 修改台账月
        ledgerVisible: false,
        ledgerLoad: false,
        ledger: '',
        ledgerData: [],
        importLoading: false,
        tableData: [],
        tableLoading: false,
      };
    },
    filters: {
      tableValueFormat(val, rowName) {
        if (rowName === 'isReconciliation') {
          switch (parseInt(val)) {
            case 0:
              return '否';
            case 1:
              return '是';
            case 2:
              return '部分生成';
          }
        } else if (rowName === 'isAdd') {
          if (val === null) {
            return '否';
          }
          switch (parseInt(val)) {
            case 0:
              return '否';
            case 1:
              return '是';
          }
        } else if (rowName === 'plannedDate') {
          return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
        } else if (rowName === 'dispatchDate') {
          return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
        } else {
          return val;
        }
      },
    },
    computed: {
      // 运输方式下拉框数据
      getTerms() {
        // console.log('getTerms');
        return function (terms) {
          switch (terms) {
            case 1:
              return '公路';
            case 2:
              return '水路';
            case 3:
              return '水陆联运';
          }
        };
      },
      // 是否生成对账单下拉框数据
      getState() {
        // console.log('getState');
        return function (state) {
          switch (state) {
            case 0:
              return '否';
            case 1:
              return '是';
          }
        };
      },
    },
    watch: {},
    mounted() {
      // this.allTrSelect(this.dataOne);
      // this.searchBtn();
    },
    methods: {
      // 是否生成补结算格式化
      isAddFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '否';
          case 1:
            return '是';
          default:
            return '否';
        }
      },
      priceFormat(row) {
        if (row.taxContractPrice && row.carNumber) return row.taxContractPrice / row.carNumber;
        return '--';
      },
      // 常规车/资源车 切换
      typeFun(val) {
        this.carType = val;
        this.$nextTick(() => {
          // this.searchBtn();
          this.dataOne = [];
          this.total = 0;
        });
      },
      // 重置方法
      resetBtn() {
        this.stateIpt = '';
        this.batchIpt = '';
        this.waybillIpt = '';
        this.chassisIpt = '';
        this.brandIpt = '';
        this.monthIpt = '';
        this.entrustIpt = '';
        this.dealersIpt = ['', ''];
        this.timeIpt = ['', ''];
        this.termsIpt = '';
        this.isAdd = '';
        this.actNoAdd = '';
        this.titleAdd = '';
      },
      // 页面查询调用方法
      searchBtn() {
        this.page = 1;
        this._shippingFeeSettlement();
      },
      compareDate(d1, d2) {
        return new Date(d1.replace(/-/g, '\/')) > new Date(d2.replace(/-/g, '\/'));
      },
      dateChange1(val) {
        if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      dateChange2(val) {
        if (this.dealersIpt[1] && this.dealersIpt[0] && this.compareDate(this.dealersIpt[0], this.dealersIpt[1])) {
          if (val == this.dealersIpt[1]) this.dealersIpt[1] = '';
          if (val == this.dealersIpt[0]) this.dealersIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 生成对账单按钮 —— 提示
      addBtn() {
        if (this.checkData.length <= 0) {
          return this.$message.warning('请至少选择一条结算数据！');
        }
        let consignorFlag = false; // 委托商
        let taxFlag = false; // 税率
        let reconciliationFlag = false; // 是否生成对账单
        if (this.checkData.length > 0) {
          const { consignorId, taxRate } = this.checkData[0];
          this.checkData.forEach(item => {
            if (item.consignorId !== consignorId) {
              consignorFlag = true;
            }
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
            if (item.isReconciliation) {
              reconciliationFlag = true;
            }
          });
        }
        if (consignorFlag) return this.$message.warning('只能选择同一家委托商数据！');
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');
        if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');

        this.$confirm('请选择结算方式', '提示', {
          confirmButtonText: '合同价',
          cancelButtonText: '预结算',
          distinguishCancelAndClose: true,
          type: 'warning',
        })
          .then(() => {
            let type = false;
            this.checkData.forEach(item => {
              if (
                !item.taxContractPrice ||
                item.taxContractPrice == '' ||
                !item.contractPrice ||
                item.contractPrice == ''
              ) {
                type = true;
              }
            });
            if (type) return this.$message.warning('操作失败，部分结算暂无合同价！');
            this.settlement = 1;
            // 生成对账单弹窗显示
            this.dialogVisible = true;
            this.$nextTick(() => {
              // 传入表格数据
              this.$refs.accountState.init(this.checkData);
              this.carType === 1
                ? (this.$refs.accountState.type = 10)
                : (this.$refs.accountState.type = 1);
            });
            // 判断是否是导入生成对账单
            this.importShow = false;
          })
          .catch(action => {
            if (action == 'close') return false;
            let type = false;
            let state = false;
            this.checkData.forEach(item => {
              if (
                item.taxContractPrice &&
                item.taxContractPrice != '' &&
                item.contractPrice &&
                item.contractPrice != ''
              ) {
                type = true;
              }
            });
            if (type) return this.$message.warning('部分数据只能使用合同价！');
            this.checkData.forEach(item => {
              if (
                !item.taxPreparePrice ||
                item.taxPreparePrice == '' ||
                !item.preparePrice ||
                item.preparePrice == ''
              ) {
                state = true;
              }
            });
            if (state) return this.$message.warning('操作失败，部分结算暂无预结算价！');
            this.settlement = 2;
            // 生成对账单弹窗显示
            this.dialogVisible = true;
            this.$nextTick(() => {
              // 传入表格数据
              this.$refs.accountState.init(this.checkData);
              this.carType === 1
                ? (this.$refs.accountState.type = 10)
                : (this.$refs.accountState.type = 1);
            });
            // 判断是否是导入生成对账单
            this.importShow = false;
          });
      },
      // 刷新结算按钮
      async addResetBtn() {
        let res;
        this.carType === 0 ? (this.$refs.checkTable.loadTable = true) : (this.tableLoading = true);
        if (this.carType === 1) {
          res = await consignmentRefreshAccount();
        } else {
          res = await refreshAccount();
        }
        this.carType === 0
          ? (this.$refs.checkTable.loadTable = false)
          : (this.tableLoading = false);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this._shippingFeeSettlement();
      },
      // 关闭弹窗并刷新页面
      closeDialogAndSearch() {
        this.dialogClose();
        this.searchBtn();
      },
      // 每页显示行数切换
      contractSizeChange(sizes) {
        this.size = sizes;
        this._shippingFeeSettlement();
      },

      // 跳转到某一页/切换页码
      contractCurrentChange(page) {
        this.page = page;
        this._shippingFeeSettlement();
      },
      // 保存生成对账单数据
      saveClick() {
        // console.log('saveClick');
      },
      // 关闭生成对账单弹窗
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.accountState.activeName = 'information';
      },
      // 不知道没有调用
      addClick() {
        // console.log('addClick');
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.basicInfoData = {};
            this.dialogVisible = false;
          } else {
            return false;
          }
        });
      },

      // 运单费用中删除某一行数据
      deleteClick() {
        // console.log('deleteClick');
      },

      // 选中数组改变
      checkChang(data) {
        this.checkData = [...new Set(data)];
      },
      // 弹窗中删除指定下标数据
      delCheck(index) {
        this.$refs.del.cancelCheck(index);
      },
      // 导入生成对账单
      importStatement() {
        // 生成对账单弹窗显示
        this.dialogVisible = true;
        //  判断是否是导入生成对账单
        this.importShow = true;
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        let url;
        this.carType === 1
          ? (url = baseUrl + '/platform/settlement/consignorLine/exportResourcesCarXls')
          : (url = baseUrl + '/platform/settlement/consignorLine/exportXls?access_token=' + token);
        const exportParams = {
          consignorName: this.entrustIpt,
          batchNumber: this.batchIpt,
          waybillNo: this.waybillIpt,
          frameNumber: this.chassisIpt,
          brandName: this.brandIpt,
          standingBookMonth: this.monthIpt,
          transportationTerms: this.termsIpt,
          planStartDate: this.timeIpt[0] || '',
          planEndDate: this.timeIpt[1] || '',
          deliveryStartDate: this.dealersIpt[0] || '',
          deliveryEndDate: this.dealersIpt[1] || '',
          isReconciliation: this.stateIpt,
          isAdd: this.isAdd,
        };
        if (this.carType === 1) {
          // window.location.href = `${url}?access_token=${token}&consignorName=${this.entrustIpt}&batchNumber=${this.batchIpt}&waybillNo=${this.waybillIpt}&frameNumber=${this.chassisIpt}&brandName=${this.brandIpt}&standingBookMonth=${this.monthIpt}&transportationTerms=${this.termsIpt}&planStartDate=${this.timeIpt[0]}&planEndDate=${this.timeIpt[1]}&deliveryStartDate=${this.dealersIpt[0]}&deliveryEndDate=${this.dealersIpt[1]}&isReconciliation=${this.stateIpt}`;
          window.exportExcelGet('/platform/settlement/consignorLine/exportResourcesCarXls', `consignorName=${this.entrustIpt}&batchNumber=${this.batchIpt}&waybillNo=${this.waybillIpt}&frameNumber=${this.chassisIpt}&brandName=${this.brandIpt}&standingBookMonth=${this.monthIpt}&transportationTerms=${this.termsIpt}&planStartDate=${this.timeIpt[0]}&planEndDate=${this.timeIpt[1]}&deliveryStartDate=${this.dealersIpt[0]}&deliveryEndDate=${this.dealersIpt[1]}&isReconciliation=${this.stateIpt}`);
        } else {
          window.exportExcel(url, exportParams, '委托商常规车托运费用结算');
        }
      },
      // 分页查询 -- 查询条件
      _shippingFeeSettlement() {
        // console.log(this.timeIpt);
        if (!this.timeIpt) {
          this.timeIpt = ['', '']
        }
        if (!this.dealersIpt) {
          this.dealersIpt = ['', '']
        }
        const data = {
          consignorName: this.entrustIpt, // 委托商
          batchNumber: this.batchIpt, // 批次号
          waybillNo: this.waybillIpt, // 运单编号
          frameNumber: this.chassisIpt, // 车架号
          brandName: this.brandIpt, // 品牌名称
          standingBookMonth: this.monthIpt, // 台账月
          transportationTerms: this.termsIpt, // 运输方式
          planStartDate: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], // 计划日期
          planEndDate: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], // 计划日期后
          deliveryStartDate: this.dealersIpt[0] === undefined ? '' : this.dealersIpt[0], // 交车日期
          deliveryEndDate: this.dealersIpt[1] === undefined ? '' : this.dealersIpt[1], // 交车日期后
          isReconciliation: this.stateIpt, // 是否生成对账单
          isAdd: this.isAdd, // 是否生成补结算
          actNoAdd: this.actNoAdd, //补结算对账单编号
          titleAdd: this.titleAdd, //补结算对账标题
          page: this.page,
          rows: this.size,
        };
        // console.log(data);
        this.carType === 1 ? this.consignmentPage(data) : this.shippingFees(data);
      },
      // 资源车
      async consignmentPage(params) {
        console.log(params);
        this.dataOne = [];
        this.tableLoading = this.importLoading = true;
        const data = await consignmentList(params);
        this.tableLoading = this.importLoading = false;
        if (data.status !== 0) return this.$message.warning(data.message);
        this.dataOne = data.data.records;
        this.total = data.data.total;
      },
      // 分页查询 -- 调用查询接口
      async shippingFees(data) {
        const temp = this.dataOne;
        this.dataOne = [];
        this.$refs.checkTable.loadTable = this.importLoading = true;
        const res = await shippingFee(data);
        this.$refs.checkTable.loadTable = this.importLoading = false;
        if (res.status !== 0) {
          this.dataOne = temp;
          return this.$message.error(res.message);
        }
        this.total = res.data.total;
        const newRes = res.data.records.map(item => ({
          ...item,
        }));
        newRes.forEach(item => {
          !item.childs ? (item.childs = []) : item.childs;
          this.dataOne.push(item);
        });
        this.$forceUpdate();
        this.$nextTick(() => {
          if (this.carType === 0) {
            this.$refs.checkTable.defaultSelect(this.checkData, this.dataOne);
          }
        });
      },
      //常规车到资源车
      async regularToResource(){
        if(this.chassisIpt === '' || this.monthIpt === '')return this.$message.warning('请先输入台账月和车架号')
        this.tableLoading = true
        const res = await changeResource({
          frameNumber:this.chassisIpt,
          standingBookMonth : this.monthIpt
        })
        this.tableLoading = false
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
      },
      /**
       *
       * @param carType 0 常规车 1 资产车
       * @returns {Promise<ElMessageComponent>}
       */
      // 价格刷新
      async priceRefresh(carType) {
        this.importLoading = true;
        if (this.entrustIpt === null || this.entrustIpt === undefined || this.entrustIpt === '') {
          this.importLoading = false;
          return this.$message.warning('操作失败，委托商必填！');
        }
        const data = {
          consignorName: this.entrustIpt, // 委托商
          batchNumber: this.batchIpt, // 批次号
          waybillNo: this.waybillIpt, // 运单编号
          frameNumber: this.chassisIpt, // 车架号
          brandName: this.brandIpt, // 品牌名称
          standingBookMonth: this.monthIpt, // 台账月
          transportationTerms: this.termsIpt, // 运输方式
          planStartDate: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], // 计划日期
          planEndDate: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], // 计划日期后
          deliveryStartDate: this.dealersIpt[0] === undefined ? '' : this.dealersIpt[0], // 交车日期
          deliveryEndDate: this.dealersIpt[1] === undefined ? '' : this.dealersIpt[1], // 交车日期后
          isReconciliation: this.stateIpt, // 是否生成对账单
          isAdd: this.isAdd, // 是否生成补结算
          actNoAdd: this.actNoAdd, //补结算对账编号
          titleAdd: this.titleAdd, //补结算对账标题
        };
        const { status, message } =
          carType === 0
            ? await consignOrLinePriceRefresh(data)
            : await consignOrLineConsignor(data);
        this.importLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
      },
      // 修改台账月 -- 打开弹窗
      // ledgerRevise() {
      //   if (!this.checkData.length || this.checkData.length == 0) return this.$message.error('请选择至少一条数据！');
      //   if (this.checkData.length > 100) return this.$message.error('最多选择100条数据！');
      //   this.ledgerData = this.checkData;
      //   this.ledgerVisible = true;
      // },
      /* // 修改台账月 -- 台账月改变
    leadChange(val) {
      if (this.ledgerData.length > 0) {
        this.ledgerData.forEach((item) => {
          item.standingBookMonth = val;
        });
      }
    }, */
      // 修改台账月 -- 删除
      delLedger(index) {
        this.ledgerData.splice(index, 1);
      },
      // 修改台账月 -- 确认
      async ledgerChange() {
        const params = {
          standingBookMonth: this.ledger,
          childs: [],
        };
        this.ledgerData.forEach(res => {
          params.childs.push({ id: res.id });
        });
        let data;
        if (this.carType === 1) {
          data = await updateStandingBookMonth(params);
        } else {
          data = await updateBatchStandingBookMonth(params);
        }
        if (data.status !== 0) return this.$message.warning(data.message);
        this.ledgerVisible = false;
        this._shippingFeeSettlement();
      },
      // 修改台账月 -- 取消(关闭弹窗)
      ledgerClose() {
        this.ledger = '';
        this.ledgerData = [];
        this.ledgerVisible = false;
      },
      rowStyle({ row }) {
        return this.checkData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkData = val;
        let Waybill = '';
        const array = val.filter((item, index) => {
          if (index === 0) Waybill = item.consignorName;
          return Waybill !== item.consignorName;
        });
        // 筛选  供应商相同数据
        this.checkData = val.filter(item => Waybill === item.consignorName);
        let tipOne = true;
        array.forEach(value => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          if (tipOne) {
            this.$message.warning('只能选择相同的供应商');
            tipOne = false;
          }
          this.$refs.multipleTable.toggleRowSelection(
            this.TableDatas.find(item => value.id === item.id),
            false,
          );
        });

        // this.$refs.accountState.calculation()
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        splitArr =
          splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'chassisIpt':
            this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },

      download() {
        window.location.href = '/file/委托商托运费导入模板（资源车）.xlsx';
      },
      changeImportLoading(flag) {
        this.importLoading = flag;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    margin-top: 25px;
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 339px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 80px;
        text-align: right;
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 15px;

      &Nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &Left {
          ::v-deep {
            .el-checkbox__label {
              color: #727070;
              font-size: 12px;
            }
          }
        }

        &Right {
          span {
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-checkbox {
            margin-left: 16px;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox:after {
            color: rgb(127, 127, 127);
            content: '全选';
            font-size: 12px;
            font-weight: 700;
            //margin-left: 2px;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox {
            margin-left: 8px;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 20px;

      &Basic {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
      }

      ::v-deep.feight {
        .el-table__expanded-cell {
          padding: 0;
          text-align: end;

          .el-table {
            left: 10%;
          }
        }

        .el-table__expand-icon > i {
          display: none;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }

        .el-table th > .cell {
          font-weight: 700 !important;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }

      ::v-deep {
        .el-tabs__active-bar {
          height: 4px;
        }

        .el-tabs__nav-wrap::after {
          height: 4px;
        }

        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }
    }

    .permissions {
      width: 100%;
      padding: 20px 10px 20px 50px;

      .name {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          color: #2f1010;
        }
      }

      .content1 {
        p {
          color: #2f1010;
        }
      }

      .tree {
        border: 1px solid #d2d2d2;
        width: 400px;
        height: 280px;
        margin-left: 60px;
        border-radius: 5px;
        padding: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .ledger {
      padding: 20px;
      max-height: calc(70vh - 60px);
      overflow-y: auto;

      .leader-input {
        display: inline-block;
        width: 100%;
        margin-bottom: 15px;

        span {
          display: inline-block;
          width: 100px;
        }

        ::v-deep {
          .el-input.el-input--small {
            display: inline-block;
            width: 200px;
          }
        }
      }

      span.dialog-footer {
        display: inline-block;
        width: 100%;
        padding: 20px 0 10px;
        text-align: center;
      }

      ::v-deep {
        .el-table td {
          padding: 5px;
        }

        .el-table td,
        .el-table th {
          font-size: 13px;
          padding: 5px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
  }

  ::v-deep {
    .consignorAccount {
      max-height: 500px;
      overflow: auto;
    }
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
